export default "__VITE_ASSET__DnysWUfn__"